import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=6d5d465d&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5d465d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d5d465d')) {
      api.createRecord('6d5d465d', component.options)
    } else {
      api.reload('6d5d465d', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=6d5d465d&scoped=true&", function () {
      api.rerender('6d5d465d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2E9x1B5henl52/JS/comp/Accordion.vue"
export default component.exports